import { z } from 'zod'
import { Currency } from '../../../enums/currency.enum'
import { isoDate } from '../expenses-by-category/iso-date'
import { monthsInRange } from '../date-range.util'
import { EXPENSE_COMPOSITION_GRANULARITIES, isGranularityAllowed } from './granularity'

// same cap as the expenses-by-category report: the aggregation scans every
// expense in the range and converts each at its own date's FX rate, so the
// range — not the bucket count — is what has to stay bounded.
const MAX_RANGE_MONTHS = 36

export const expenseCompositionQuerySchema = z
  .object({
    from: isoDate,
    to: isoDate,
    baseCurrency: z.nativeEnum(Currency).optional(),
    granularity: z.enum(EXPENSE_COMPOSITION_GRANULARITIES).default('month'),
  })
  .refine((q) => q.from <= q.to, { message: 'from must be on or before to', path: ['from'] })
  .refine((q) => monthsInRange(q.from, q.to) <= MAX_RANGE_MONTHS, {
    message: `range must not exceed ${MAX_RANGE_MONTHS} months`,
    path: ['to'],
  })
  // enforced server-side too, not just greyed out in the picker — otherwise a
  // hand-rolled `granularity=day` over three years would return ~1100 buckets.
  .refine((q) => isGranularityAllowed(q.from, q.to, q.granularity), {
    message: 'granularity is too fine for the selected range',
    path: ['granularity'],
  })

export type ExpenseCompositionQueryDto = z.infer<typeof expenseCompositionQuerySchema>

export const EXPENSE_COMPOSITION_MAX_RANGE_MONTHS = MAX_RANGE_MONTHS
